/* eslint-disable @typescript-eslint/no-explicit-any */
import { Action, Store } from 'redux'
import { ThunkAction } from 'redux-thunk'
import {
  ACCEPT_EMAIL_INVITATION_URL,
  GET_AGENCIES_DETAIL_URL,
  GET_AVERAGE_TIME_TO_FILL_DATA_URL,
  GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_URL,
  GET_OVERALL_SUBMISSION_STATS_DATA_URL,
  GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_URL,
  GET_RECRUITMENT_AGENCIES_REQUEST_LIST_URL,
  GET_RECRUITMENT_JD_LIST_URL,
  GET_RECRUITMENT_SHARED_CANDIDATE_LIST_URL,
  GET_SUBMISSION_TRACK_DATA_URL,
  RECRUITMENT_AGENCIES_LIST_URL,
  SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_URL,
} from '../../service/apiEndPoints'
import { apiCall, METHOD } from '../../service/baseApiCall'
import {
  ACCEPT_EMAIL_INVITATION,
  GET_AGENCIES_DETAIL,
  GET_AVERAGE_TIME_TO_FILL_DATA,
  GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA,
  GET_OVERALL_SUBMISSION_STATS_DATA,
  GET_RECRUITMENT_ACTIVE_JD_LIST,
  GET_RECRUITMENT_AGENCIES_LIST,
  GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL,
  GET_RECRUITMENT_AGENCIES_REQUEST_LIST,
  GET_RECRUITMENT_SHARED_CANDIDATE_LIST,
  GET_SUBMISSION_TRACK_DATA,
  RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE,
  SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST,
} from '../constants/action-types'
import { showErrorToastMessage } from '../../util/utils'

// ************** GET_RECRUITMENT_LIST ******************
export const getRecruitmentAgenciesThunk = (
  payload?: object
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_RECRUITMENT_AGENCIES_LIST.GET_RECRUITMENT_AGENCIES_LIST_INITIALIZATION,
    })
    apiCall(
      RECRUITMENT_AGENCIES_LIST_URL,
      (res) => {
        dispatch({
          type: GET_RECRUITMENT_AGENCIES_LIST.GET_RECRUITMENT_AGENCIES_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      (err) => {
        dispatch({
          type: GET_RECRUITMENT_AGENCIES_LIST.GET_RECRUITMENT_AGENCIES_LIST_ERROR,
        })
        showErrorToastMessage('Something went wrong')
      },
      { params: { ...payload } },
      METHOD.GET,
      { showToast: false }
    )
  }
}

// ************** GET_RECRUITMENT_AGENCY_DETAIL ******************
export const getAgenciesDetailThunk = (
  id
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_AGENCIES_DETAIL.GET_AGENCIES_DETAIL_INITIALIZATION,
    })
    apiCall(
      GET_AGENCIES_DETAIL_URL(id),
      (res) => {
        dispatch({
          type: GET_AGENCIES_DETAIL.GET_AGENCIES_DETAIL_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_AGENCIES_DETAIL.GET_AGENCIES_DETAIL_ERROR,
        })
        showErrorToastMessage('Something went wrong')
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }
}

// ************** GET_RECRUITMENT_AGENCY_REQUESTED_LIST ******************
export const getRecruitmentAgenciesRequestListThunk = (
  payload
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_RECRUITMENT_AGENCIES_REQUEST_LIST.GET_RECRUITMENT_AGENCIES_REQUEST_LIST_INITIALIZATION,
    })
    apiCall(
      GET_RECRUITMENT_AGENCIES_REQUEST_LIST_URL,
      (res) => {
        dispatch({
          type: GET_RECRUITMENT_AGENCIES_REQUEST_LIST.GET_RECRUITMENT_AGENCIES_REQUEST_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_RECRUITMENT_AGENCIES_REQUEST_LIST.GET_RECRUITMENT_AGENCIES_REQUEST_LIST_ERROR,
        })
        showErrorToastMessage('Something went wrong')
      },
      { params: { ...payload } },
      METHOD.GET,
      { showToast: false }
    )
  }
}

// ************** GET_RECRUITMENT_AGENCY_REQUESTED_DETAIL ******************
export const getRecruitmentAgenciesRequestDetailThunk = (
  id
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL.GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_INITIALIZATION,
    })
    apiCall(
      GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_URL(id),
      (res) => {
        dispatch({
          type: GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL.GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL.GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_ERROR,
        })
        showErrorToastMessage('Something went wrong')
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }
}

// ************** RECRUITMENT_AGENCY_ACCEPT_OR_DECLINE_REQUEST ******************
export const recruitmentAgenciesRequestAcceptDeclineThunk = (
  payload: {
    id: number | string | undefined
    status: number | string | undefined
  },
  _handleSuccess
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE.RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_INITIALIZATION,
    })

    apiCall(
      GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_URL(payload?.id),
      () => {
        dispatch({
          type: RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE.RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_SUCCESS,
        })
        _handleSuccess()
      },
      () => {
        dispatch({
          type: RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE.RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_ERROR,
        })
      },
      {
        status: payload?.status,
      },
      METHOD.PATCH,
      { showToast: true }
    )
  }
}

// ************** SEND_REQUEST_TO_RECRUITMENT_AGENCY ******************
export const sendConnectionRequestThunk = (
  payload,
  redirectHandler
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST.SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_INITIALIZATION,
    })
    apiCall(
      SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_URL,
      (res) => {
        dispatch({
          type: SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST.SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_SUCCESS,
          payload: res,
        })
        redirectHandler()
      },
      () => {
        dispatch({
          type: SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST.SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_ERROR,
        })

        showErrorToastMessage('Something went wrong')
      },
      {
        institute: payload?.institute || undefined,
        agency: payload?.agency || undefined,
        requested_by: payload?.requested_by || undefined,
        agency_request_details: payload?.agency_request_details || undefined,
      },
      METHOD.POST,
      { showToast: true }
    )
  }
}

export const acceptEmailInvitationThunk =
  (
    req_id: number | string | undefined,
    status?: string | undefined,
    handleSuccess?: () => void,
    handleError?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ACCEPT_EMAIL_INVITATION.ACCEPT_EMAIL_INVITATION_INITIALIZATION,
    })
    apiCall(
      ACCEPT_EMAIL_INVITATION_URL(req_id),
      (res) => {
        dispatch({
          type: ACCEPT_EMAIL_INVITATION.ACCEPT_EMAIL_INVITATION_SUCCESS,
          payload: res,
        })
        handleSuccess && handleSuccess()
      },
      () => {
        dispatch({
          type: ACCEPT_EMAIL_INVITATION.ACCEPT_EMAIL_INVITATION_ERROR,
        })
        handleError && handleError()
        showErrorToastMessage('Something went wrong')
      },
      { status: status },
      METHOD.PUT,
      { showToast: false }
    )
  }

// ************** GET_RECRUITMENT_ACTIVE_JD_LIST ******************
export const getRecruitmentActiveJDListThunk = (
  payload
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_RECRUITMENT_ACTIVE_JD_LIST.GET_RECRUITMENT_ACTIVE_JD_LIST_INITIALIZATION,
    })
    apiCall(
      GET_RECRUITMENT_JD_LIST_URL,
      (res) => {
        dispatch({
          type: GET_RECRUITMENT_ACTIVE_JD_LIST.GET_RECRUITMENT_ACTIVE_JD_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_RECRUITMENT_ACTIVE_JD_LIST.GET_RECRUITMENT_ACTIVE_JD_LIST_FAILED,
        })
        showErrorToastMessage('Something went wrong')
      },
      { params: { ...payload } },
      METHOD.GET,
      { showToast: false }
    )
  }
}

// ************** GET_RECRUITMENT_ACTIVE_JD_LIST ******************
export const getRecruitmentSharedCandidateListThunk = (
  payload
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_RECRUITMENT_SHARED_CANDIDATE_LIST.GET_RECRUITMENT_SHARED_CANDIDATE_LIST_INITIALIZATION,
    })
    apiCall(
      GET_RECRUITMENT_SHARED_CANDIDATE_LIST_URL,
      (res) => {
        dispatch({
          type: GET_RECRUITMENT_SHARED_CANDIDATE_LIST.GET_RECRUITMENT_SHARED_CANDIDATE_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_RECRUITMENT_SHARED_CANDIDATE_LIST.GET_RECRUITMENT_SHARED_CANDIDATE_LIST_FAILED,
        })
        showErrorToastMessage('Something went wrong')
      },
      { params: { ...payload } },
      METHOD.GET,
      { showToast: false }
    )
  }
}

// ************** GET_AVERAGE_TIME_TO_FILL_DATA ******************
export const getAverageTimeToFillDataThunk = (
  instituteId,
  payload
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_AVERAGE_TIME_TO_FILL_DATA.GET_AVERAGE_TIME_TO_FILL_DATA_INITIALIZATION,
    })
    apiCall(
      GET_AVERAGE_TIME_TO_FILL_DATA_URL(instituteId),
      (res) => {
        dispatch({
          type: GET_AVERAGE_TIME_TO_FILL_DATA.GET_AVERAGE_TIME_TO_FILL_DATA_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_AVERAGE_TIME_TO_FILL_DATA.GET_AVERAGE_TIME_TO_FILL_DATA_FAILED,
        })
      },
      { params: { ...payload } },
      METHOD.GET,
      { showToast: false }
    )
  }
}

// ************** GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA ******************
export const getCandidateQualityDistributionThunk = (
  instituteId,
  payload
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA.GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_INITIALIZATION,
    })
    apiCall(
      GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_URL(instituteId),
      (res) => {
        dispatch({
          type: GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA.GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA.GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_FAILED,
        })
      },
      { params: { ...payload } },
      METHOD.GET,
      { showToast: false }
    )
  }
}

// ************** GET_SUBMISSION_TRACK_DATA ******************
export const getSubmissionTrackThunk = (
  instituteId,
  payload,
  handleSuccess?: () => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_SUBMISSION_TRACK_DATA.GET_SUBMISSION_TRACK_DATA_INITIALIZATION,
    })
    apiCall(
      GET_SUBMISSION_TRACK_DATA_URL(instituteId),
      (res) => {
        dispatch({
          type: GET_SUBMISSION_TRACK_DATA.GET_SUBMISSION_TRACK_DATA_SUCCESS,
          payload: res?.data,
        })
        handleSuccess && handleSuccess()
      },
      () => {
        dispatch({
          type: GET_SUBMISSION_TRACK_DATA.GET_SUBMISSION_TRACK_DATA_FAILED,
        })
      },
      { params: { ...payload } },
      METHOD.GET,
      { showToast: false }
    )
  }
}

// ************** GET_OVERALL_SUBMISSION_STATS_DATA ******************
export const getOverallSubmissionStatsThunk = (
  instituteId,
  payload,
  handleSuccess?: (...args) => void
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_OVERALL_SUBMISSION_STATS_DATA.GET_OVERALL_SUBMISSION_STATS_DATA_INITIALIZATION,
    })
    apiCall(
      GET_OVERALL_SUBMISSION_STATS_DATA_URL(instituteId),
      (res) => {
        dispatch({
          type: GET_OVERALL_SUBMISSION_STATS_DATA.GET_OVERALL_SUBMISSION_STATS_DATA_SUCCESS,
          payload: res?.data,
        })
        handleSuccess && handleSuccess(res?.data)
      },
      () => {
        dispatch({
          type: GET_OVERALL_SUBMISSION_STATS_DATA.GET_OVERALL_SUBMISSION_STATS_DATA_FAILED,
        })
      },
      { params: { ...payload } },
      METHOD.GET,
      { showToast: false }
    )
  }
}
